// Document catalogue for the Documents tab workbench.
//
// Moved from `ClaimDocumentsTab.tsx` (see design Section 6.1). Adds
// `required`/`requiredGroup` flags per design Section 6.3: the three
// payment-proof variants are mutually exclusive by claim type, so they share
// ONE `requiredGroup: 'payment_proof'` rather than three independent
// `required: true` flags — "Missing Required" treats the group as satisfied
// if ANY ONE of the three is uploaded.

import type { DocDef } from './types';

export const DOCUMENT_GROUPS: { group: string; docs: DocDef[] }[] = [
  {
    group: 'Financial Documents',
    docs: [
      { key: 'repair_invoice_1',           label: 'Repair Invoice 1',                          required: true,  hint: 'Up to 3 invoices' },
      { key: 'repair_invoice_2',           label: 'Repair Invoice 2',                          required: true },
      { key: 'repair_invoice_3',           label: 'Repair Invoice 3',                          required: false },
      { key: 'estimate_1',                 label: 'Estimate 1',                                required: false, hint: 'Up to 3 estimates' },
      { key: 'estimate_2',                 label: 'Estimate 2',                                required: false },
      { key: 'estimate_3',                 label: 'Estimate 3',                                required: false },
      { key: 'payment_proof_cashless',     label: 'Proof of Payment — Cashless Claim',         required: false, requiredGroup: 'payment_proof' },
      { key: 'payment_proof_non_cashless', label: 'Proof of Payment — Non-Cashless Claim',     required: false, requiredGroup: 'payment_proof' },
      { key: 'payment_proof_full',         label: 'Proof of Payment — Full Claim by Insured',  required: false, requiredGroup: 'payment_proof' },
      { key: 'satisfaction_voucher',       label: 'Satisfaction Voucher',                      required: true },
      { key: 'cancelled_cheque',           label: 'Cancelled Cheque / Bank Details',           required: true },
    ],
  },
  {
    group: 'Identity Documents',
    docs: [
      { key: 'aadhaar_card', label: 'Aadhaar Card', required: true },
      { key: 'pan_card',     label: 'PAN Card',     required: true },
      { key: 'dl_front',     label: 'DL Front',     required: true },
      { key: 'dl_back',      label: 'DL Back',      required: true },
    ],
  },
  {
    group: 'Vehicle Documents',
    docs: [
      { key: 'rc_front',   label: 'RC Front',      required: true },
      { key: 'rc_back',    label: 'RC Back',       required: true },
      { key: 'permit',     label: 'Permit',        required: true },
      { key: 'fitness_fc', label: 'Fitness / FC',  required: true },
    ],
  },
  {
    group: 'Insurance Documents',
    docs: [
      { key: 'policy_copy',  label: 'Policy',       required: true },
      { key: 'gc_policy',    label: 'GC Policy',    required: false, hint: 'Goods Carrier Policy' },
      { key: 'claims_form',  label: 'Claims Form',  required: true },
    ],
  },
  {
    group: 'Authorization Documents',
    docs: [
      { key: 'permit_authorization', label: 'Permit Authorization', required: true },
    ],
  },
];
